import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

declare function PhotoSphereViewer(any): any;

@Component({
    selector: 'app-photo-viewer',
    templateUrl: './photo-viewer.component.html',
    styleUrls: ['./photo-viewer.component.scss']
})
export class PhotoViewerComponent implements OnInit, AfterViewInit {

    @Input() url: any;

    constructor() {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        let viewer = PhotoSphereViewer({
            container: 'container-id',
            panorama: this.url,
            cors_anonymous: false,
            gyroscope: true,
            navbar: [
                'autorotate',
                'zoom',
                'caption',
                'fullscreen',
                'gyroscope'
            ]
        });

    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/shared/photo-viewer/photo-viewer.component.ts